import styled, { createGlobalStyle } from 'styled-components';

import { fontFamilyBase, fontWeightMedium } from './typography.style';
import { mediaUp } from 'approot/shared/style';
import { ReactModalCss } from 'lib/modal/modal.style';
import { PrintCss } from './print.style';
import { RebootCss } from './reboot.style';
import { ProductTourAnimationCss } from 'approot/shared/product-tours/product-tour-animation.style';
import { AstryxOverridesCss } from './astryx-overrides.style';
import { AstryxUnresetCss } from './astryx-unreset.style';

export const GlobalStyles = createGlobalStyle`
  /* Layer order: our Bootstrap Reboot lowest, then Astryx's reset, then
     inq-unreset (see astryx-unreset.style.tsx), then Astryx's own component and
     theme layers. Unlayered styles still beat all of them. */
  @layer inq-reboot, reset, inq-unreset, astryx-base, astryx-theme;

  ${AstryxUnresetCss}

  html,
  body {
    font-family: ${fontFamilyBase};
    min-width: 280px;
  }

  html {
    min-height: 100%;
    color-scheme: light;
  }

  body {
    overflow-x: hidden;
  }

  strong {
    font-weight: ${fontWeightMedium};
  }

  ${ReactModalCss}
  ${PrintCss}

  @layer inq-reboot {
    ${RebootCss}
  }

  ${ProductTourAnimationCss}

  ${AstryxOverridesCss}
`;

export const ScreenReaderOnly = styled.div`
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
`;

export const ScreenSmallOnlyStyled = styled.span`
  display: block;
  ${mediaUp.md`
    display: none;
  `}
`;

export const ScreenMediumOnlyStyled = styled.span`
  display: none;
  ${mediaUp.md`
    display: block;
  `}
`;
